module.exports = __webpack_public_path__ + "img/Avatar-54.d519b3b6.svg";